import { User } from '@brighte/passwordless-authenticator';
import {
  APPLICATION_SUBMITTED,
  APPROVED_PAGE_TITLE,
  PRIMARY_APPLICATION_SUBMITTED,
  UNDER_REVIEW_PAGE_TITLE,
} from '../../utils';

// given_name isn't always on the Auth0 token — fall back rather than leave a dangling comma.
export const getApprovedPageTitle = (user?: User | null) => {
  return user?.given_name ? `${APPROVED_PAGE_TITLE}, ${user.given_name}` : APPROVED_PAGE_TITLE;
};

export const getUnderReviewPageTitle = (user?: User | null) => {
  return user?.given_name ? `${UNDER_REVIEW_PAGE_TITLE}, ${user.given_name}` : UNDER_REVIEW_PAGE_TITLE;
};

export const getSubmittedPageTitle = (hasJoint: boolean, isJointForm: boolean) => {
  if (hasJoint || isJointForm) {
    return PRIMARY_APPLICATION_SUBMITTED;
  }
  return APPLICATION_SUBMITTED;
};
